import React from 'react';

function ToggleSwitch({ enabled, setEnabled }) {
  return (
    <div
      className={`relative inline-flex h-6 w-11 items-center rounded-full cursor-pointer transition duration-300 ${enabled ? 'bg-[#04b394]' : 'bg-gray-300'}`}
      onClick={() => setEnabled(!enabled)}
    >
      <div
        className={`h-4 w-4 bg-white rounded-full shadow-md transform transition duration-300 ${enabled ? 'translate-x-6' : 'translate-x-1'}`}
      />
    </div>
  );
}

export default ToggleSwitch;
